import React from 'react';
import Button from '@mui/material/Button';
import {
  LOIN_INTER, NOT_PREST
} from '@lba-dev/package.local-globals/statusProsp';

import MinCustomDialog from '../Dialogs/MinCustomDialog';
import CustomTextField from '../CustomInputs/CustomTextField';

const titles = {
  [LOIN_INTER]: 'Titre de la ville concernée',
  [NOT_PREST]: 'La prestation concernée'
};

const DialogComment = ({ open, updateData, comment, status, validate }) => (
  <MinCustomDialog
    open={open}
    maxWidth={'xs'}
    onClose={() => updateData('openComment', false)}
    title={titles[status] || 'Commentaire'}
    actions={[
      <Button key={1} onClick={validate} color="primary"> Valider </Button>,
    ]}
    middle children={<CustomTextField
      value={comment}
      path={['comment']}
      texttransform={'none'}
      setData={updateData}
      rows={5}
      multiline={true}
    />
    } />
);

export default (DialogComment);
